import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/home/runner/work/web/web/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GradientBalls"] */ "/home/runner/work/web/web/src/components/Backgrounds/GradientBalls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GalleryImage"] */ "/home/runner/work/web/web/src/components/Blog/GalleryImage.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeadingAnchors"] */ "/home/runner/work/web/web/src/components/Blog/HeadingAnchors.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/home/runner/work/web/web/src/components/Blog/ShareButton.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmoothLink"] */ "/home/runner/work/web/web/src/components/Blog/SmoothLink.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/home/runner/work/web/web/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/components/Media/PayloadImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/home/runner/work/web/web/src/components/Media/VideoMedia/index.tsx");
